/* global $ */

import { ModalSearch } from '../smart_bps/bps/modal_search'

export class SigurModalSearch extends ModalSearch {
  constructor(props) {

    super(props)
    this.onClean = this.onClean.bind(this)
  }

  onClean() {
    const emptyData = {};
    Object.entries(this.state.data || {}).map(([fieldName, fieldVal]) => {
      if (typeof fieldVal === 'string') emptyData[fieldName] = null
    })
    this.setState({ data: emptyData });
  }
  onSearch() {
    const searchData = Object.fromEntries(
      Object.entries(this.state.data || {}).filter(([fieldName, fieldVal]) => {
        if (fieldVal === null || fieldVal === undefined || fieldVal === '') {
            return false;
        }
        if (Array.isArray(fieldVal) && fieldVal.length === 0) {
            return false;
        }
        return true;
      })
    );

    this.props.onSearch(searchData);
    $('#modal_search').modal('hide');
}

}